import { Tooltip } from '@mui/material'
import { NotificationsActive } from '@mui/icons-material'
import { PrometheusAlert, RuuviTag } from '../types'
import BlinkingComponent from './BlinkingComponent'
import { translateAlertRuleName } from '../utils/alert'
import { useNavigate } from 'react-router-dom'

interface RuuviTagAlertIndicatorProps {
  /**
   * The ruuviTag.
   */
  ruuviTag: RuuviTag

  /**
   * The alerts.
   */
  alerts: PrometheusAlert[]

  /**
   * Indicates if alerts are being loaded.
   */
  loading?: boolean

  /**
   * The font size.
   */
  fontSize?: 'inherit' | 'small' | 'medium' | 'large'
}

/**
 * An alert indicator for RuuviTag.
 */
export default function RuuviTagAlertIndicator({
  ruuviTag,
  alerts,
  fontSize = 'inherit'
}: RuuviTagAlertIndicatorProps) {
  /**
   * The navigate function.
   */
  const navigate = useNavigate()

  /**
   * The latest alert.
   */
  const latestAlert = alerts?.length > 0 ? alerts[0] : null

  return (
    <>
      {latestAlert && (
        <Tooltip title={translateAlertRuleName(latestAlert.labels.alertname)}>
          <BlinkingComponent>
            <NotificationsActive
              fontSize={fontSize}
              color="error"
              sx={{ cursor: 'pointer' }}
              onClick={() => navigate(`/ruuvi-tags/${ruuviTag.id}/alerts`)}
            />
          </BlinkingComponent>
        </Tooltip>
      )}
    </>
  )
}
